<custom-modal-card *ngIf="{ violations: violations$ | async }">
  <ng-container header>
    <default-modal-header
      [title]="'Configurer un Géoblocage'"
      description="Veuillez remplir les champs ci-dessous pour définir le géoblocage"
    ></default-modal-header>
  </ng-container>

  <ng-container body>
    <form [formGroup]="geoblockingForm" class="resource-form">
      <article>
        <mat-label>Sélectionnez le liveStream</mat-label>
        <mat-form-field color="primary">
          <div matPrefix class="custom-prefix">
            <img
              src="assets/icons/tag-grey.svg"
              alt="tag icon"
              width="20"
              height="20"
            />
          </div>
          <mat-select formControlName="liveStreamId">
            <mat-option
              *ngFor="let item of liveStreams$ | async"
              [value]="item.id"
              >{{ item.title }}</mat-option
            >
          </mat-select>
          <div matSuffix class="custom-suffix">
            <img
              src="assets/icons/unfold-more.svg"
              alt="unfold more icon"
              width="20"
              height="20"
            />
          </div>
        </mat-form-field>
      </article>
      <article>
        <mat-label>Sélectionnez le profil</mat-label>
        <mat-form-field color="primary">
          <div matPrefix class="custom-prefix">
            <img
              src="assets/icons/tag-grey.svg"
              alt="tag icon"
              width="20"
              height="20"
            />
          </div>
          <mat-select formControlName="accessControlId">
            <mat-option
              *ngFor="let item of accessControl$ | async"
              [value]="item.id"
              >{{ item.name }}</mat-option
            >
          </mat-select>
          <div matSuffix class="custom-suffix">
            <img
              src="assets/icons/unfold-more.svg"
              alt="unfold more icon"
              width="20"
              height="20"
            />
          </div>
        </mat-form-field>
      </article>
      <div class="resource-form__splitted-row">
        <article>
          <mat-label>A partir du</mat-label>
          <section class="flex items-center gap-2">
            <div class="grid grid-cols-3 gap-1">
              <mat-form-field class="col-span-2">
                <input
                  matInput
                  [matDatepicker]="picker"
                  formControlName="dateStartAt"
                  placeholder="Date de début"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="picker"
                ></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
              <mat-form-field>
                <input matInput type="time" formControlName="timeStartAt" />
              </mat-form-field>
            </div>
            <div
              *ngIf="
                $any(geoblockingForm.get('dateStartAt'))?.value &&
                $any(geoblockingForm.get('timeStartAt'))?.value
              "
              (click)="clearDate('startAt')"
              matSuffix
              class="custom-prefix"
            >
              <img
                src="assets/icons/close-red.svg"
                alt="icon"
                width="24"
                height="24"
              />
            </div>
          </section>
          <mat-error
            *ngIf="
              $any(geoblockingForm.get('dateStartAt'))?.getError(
                'httpError'
              ) as httpError
            "
          >
            <strong>{{ httpError }}</strong>
          </mat-error>
        </article>
        <article>
          <mat-label>Jusqu'au</mat-label>
          <section class="flex items-center gap-2">
            <div class="grid grid-cols-3 gap-1">
              <mat-form-field class="col-span-2">
                <input
                  matInput
                  [matDatepicker]="picker2"
                  formControlName="dateEndAt"
                  placeholder="Date de fin"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="picker2"
                ></mat-datepicker-toggle>
                <mat-datepicker #picker2></mat-datepicker>
              </mat-form-field>
              <mat-form-field>
                <input matInput type="time" formControlName="timeEndAt" />
              </mat-form-field>
            </div>
            <div
              *ngIf="
                $any(geoblockingForm.get('dateEndAt'))?.value &&
                $any(geoblockingForm.get('timeEndAt'))?.value
              "
              (click)="clearDate('endAt')"
              matSuffix
              class="custom-prefix"
            >
              <img
                src="assets/icons/close-red.svg"
                alt="icon"
                width="24"
                height="24"
              />
            </div>
          </section>
          <mat-error
            *ngIf="
              $any(geoblockingForm.get('dateEndAt'))?.getError('httpError') ||
              $any(geoblockingForm.get('dateStartAt'))?.getError(
                'httpError'
              ) as httpError
            "
          >
            <strong>{{ httpError }}</strong>
          </mat-error>
        </article>
      </div>
      <mat-error
        *ngIf="$any(geoblockingForm).getError('httpError') as httpError"
      >
        <strong>{{ httpError }}</strong>
      </mat-error>
    </form>
  </ng-container>

  <footer footer class="resource-form">
    <button
      type="button"
      (click)="saveGeoblocking()"
      [attr.loading]="isLoading"
      [disabled]="
        !geoblockingForm.valid || geoblockingForm.pristine || isLoading
      "
      class="btn btn--primary-light btn--full"
    >
      {{ geoblocking ? 'Sauvegarder' : 'Ajouter la configuration' }}
    </button>
  </footer>
</custom-modal-card>
